/*
 * Copyright (c) 2024-2025.
 * The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'

interface TableHeadColumnProps {
    children: React.ReactNode | React.ReactNode[]
    className?: string
    colSpan: number
    'data-column-id'?: string
}

const TableHeadColumn = (props: TableHeadColumnProps) => {
    const { 'data-column-id': dataColumnId, children, className, colSpan } = props

    return (
        <th
            data-column-id={dataColumnId}
            className={clsx(
                'TableHeadColumn px-1 last:pr-2 first:pl-2 py-2 text-left last:text-right align-top',
                className && className
            )}
            colSpan={colSpan}
        >
            {children}
        </th>
    )
}

export default TableHeadColumn
